"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var payloadAssembler_1 = require("../assemblers/payloadAssembler");
var payloadTypes_1 = require("./payloadTypes");
/**
 * Orchestrates assemly of payloads
 */
var PayloadAssemblerManager = /** @class */ (function () {
    function PayloadAssemblerManager(streamManager, onReceiveResponse, onReceiveRequest) {
        this.activeAssemblers = {};
        this.streamManager = streamManager;
        this.onReceiveRequest = onReceiveRequest;
        this.onReceiveResponse = onReceiveResponse;
    }
    PayloadAssemblerManager.prototype.getPayloadStream = function (header) {
        if (header.payloadType === payloadTypes_1.PayloadTypes.stream) {
            return this.streamManager.getPayloadStream(header);
        }
        else if (!this.activeAssemblers[header.id]) {
            var assembler = this.createPayloadAssembler(header);
            if (assembler) {
                this.activeAssemblers[header.id] = assembler;
                return assembler.getPayloadStream();
            }
        }
    };
    PayloadAssemblerManager.prototype.onReceive = function (header, contentStream, contentLength) {
        if (header.payloadType === payloadTypes_1.PayloadTypes.stream) {
            this.streamManager.onReceive(header, contentStream, contentLength);
        }
        else {
            if (this.activeAssemblers && this.activeAssemblers[header.id]) {
                var assembler = this.activeAssemblers[header.id];
                assembler.onReceive(header, contentStream, contentLength);
            }
            if (header.end) {
                delete this.activeAssemblers[header.id];
            }
        }
    };
    PayloadAssemblerManager.prototype.createPayloadAssembler = function (header) {
        if (header.payloadType === payloadTypes_1.PayloadTypes.request) {
            return new payloadAssembler_1.PayloadAssembler(this.streamManager, { header: header, onCompleted: this.onReceiveRequest });
        }
        else if (header.payloadType === payloadTypes_1.PayloadTypes.response) {
            return new payloadAssembler_1.PayloadAssembler(this.streamManager, { header: header, onCompleted: this.onReceiveResponse });
        }
    };
    return PayloadAssemblerManager;
}());
exports.PayloadAssemblerManager = PayloadAssemblerManager;
//# sourceMappingURL=payloadAssemblerManager.js.map